import _BaseUserProfile from 'Models/UserProfile/_BaseUserProfile';

export default class LongDriveAvailability extends _BaseUserProfile {
  component = 'YesNoSelection';
  props = {
    title: 'Are you interested in Jobs that require longer drives and/or overnight stays?',
    errorMessage: 'Please Answer on Question',
    additionalFormInModal: false,
    modalTitle: null,
    additionalFormComponent: null,
  };
}
